module.exports = __webpack_public_path__ + "static/media/GAPoweredByNovareLogo.bf7d95bc.png";